import { render } from "./IconFilm.vue?vue&type=template&id=6e204b34"
const script = {}

import exportComponent from "/home/production/domains/architect.youniversity.be/public_html/architect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__